import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class VersionSchema extends BaseTypeSchema
{
    static REGEX: RegExp = /^\d+\.\d+\.\d+\.\d+$/;
    constructor(required: boolean)
    {
        super(VariableType.Version, required);
    }
}